const PREFIX = 'TIPS_';

const tipsConstants = {
  TIPS_RESET: PREFIX + 'TIPS_RESET',
  LOAD_INFLUENCER_WIN_RATES_REQUEST:
    PREFIX + 'LOAD_INFLUENCER_WIN_RATES_REQUEST',
  LOAD_INFLUENCER_WIN_RATES_SUCCESS:
    PREFIX + 'LOAD_INFLUENCER_WIN_RATES_SUCCESS',
  LOAD_INFLUENCER_WIN_RATES_FAILURE:
    PREFIX + 'LOAD_INFLUENCER_WIN_RATES_FAILURE',

  FETCH_STOCK_EXPERT_TIPS_REQUEST: PREFIX + 'FETCH_STOCK_EXPERT_TIPS_REQUEST',
  FETCH_STOCK_EXPERT_TIPS_SUCCESS: PREFIX + 'FETCH_STOCK_EXPERT_TIPS_SUCCESS',
  FETCH_STOCK_EXPERT_TIPS_FAILURE: PREFIX + 'FETCH_STOCK_EXPERT_TIPS_FAILURE',
};

export default tipsConstants;
